import React from "react";

export const AlertIcon = () => {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.24935 9.25179L8.74935 11.7518L13.7493 6.75179M18.3327 9.25179C18.3327 13.8542 14.6017 17.5851 9.99935 17.5851C5.39698 17.5851 1.66602 13.8542 1.66602 9.25179C1.66602 4.64942 5.39698 0.918457 9.99935 0.918457C14.6017 0.918457 18.3327 4.64942 18.3327 9.25179Z"
        stroke="#38C280"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
